import { AssemblyState, IDefaultAssembly } from 'src/interfaces';

export const mapMultipleAssemblyState = (
  assemblyIDs: (number | string)[],
  defaultAssemblies: IDefaultAssembly[],
) => {
  return assemblyIDs.map((assemblyId) => ({
    state: mapAssemblyState(assemblyId, defaultAssemblies),
    assemblyId,
  }));
};

export const mapAssemblyState = (
  assemblyId: number | string,
  defaultAssemblies: IDefaultAssembly[],
) => {
  let state = AssemblyState.UNUSED;

  const assemblyIdSet = new Set(
    defaultAssemblies.map((item) => item.assembly_id),
  );

  if (assemblyIdSet.has(Number(assemblyId))) {
    state = AssemblyState.DEFAULT;
  }

  return state;
};
